import { Bot } from "lucide-react";
import type { ComponentType } from "react";
import type { ChatContentType, ChatMessage, ChatSendError } from "../types";
import { AIChatDownloadMessage } from "./AIChatDownloadMessage";
import { AIChatSendError } from "./AIChatSendError";
import { AIChatTableMessage } from "./AIChatTableMessage";
import { AIChatTextMessage } from "./AIChatTextMessage";
import { AIChatUserBubble } from "./AIChatUserBubble";

type Props = {
  messages: ChatMessage[];
  isGenerating?: boolean;
  sendError?: ChatSendError | null;
  onRetrySend?: () => void;
};

type MessageView = ComponentType<{ message: ChatMessage }>;

/** Map `message.type` → UI. Add a component here when you add a new extractor type. */
const MESSAGE_UI: Record<ChatContentType, MessageView> = {
  user: AIChatUserBubble,
  text: AIChatTextMessage,
  download: AIChatDownloadMessage,
  table: AIChatTableMessage,
};

export function AIChatMessageList({
  messages,
  isGenerating,
  sendError,
  onRetrySend,
}: Props) {
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-5 px-4 py-6 md:px-8">
      {messages.map((message) => {
        const View = MESSAGE_UI[message.type] ?? AIChatTextMessage;
        return <View key={message.id} message={message} />;
      })}
      {sendError && !isGenerating ? (
        <AIChatSendError onRetry={() => onRetrySend?.()} />
      ) : null}
      {isGenerating ? (
        <div className="flex items-start gap-3">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-white">
            <Bot className="h-4 w-4" />
          </span>
          <div className="rounded-xl border border-[#E5E7EB] bg-white px-4 py-3 text-sm text-[#6B7280] shadow-sm">
            Thinking…
          </div>
        </div>
      ) : null}
    </div>
  );
}
